// extracted by mini-css-extract-plugin
export default {"content":"uCj2I_nL","mobile":"mobile","text":"gWFTf1vQ","headline":"ZX69p_RR","icon":"CjezY1yc","image":"R0WR55nu","social":"PMmzI8BS","time":"VOQbd6LR"};